// extracted by mini-css-extract-plugin
export default {"container":"SuccessHeader_container__lqgbA","successIcon":"SuccessHeader_successIcon__Jb-xb"};